(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-image-cycle"] && !Shopify.designMode) return;
  try {
    
  //console.log('hero image');
  var mobile_image = document.getElementById("mobile-image");
  var desktop_small_image = document.getElementById("desktop-small-image");
  var desktop_large_image = document.getElementById("desktop-large-image");
  var i = 0;
  function volgendefoto() {
      i<mobile_images.length-1?i+=1:i=0;
      mobile_image.srcset=mobile_images[i];
      desktop_small_image.srcset=desktop_small_images[i];  
      desktop_large_image.srcset=desktop_large_images[i];  
      //console.log('Changed mobile image to: '+mobile_images[i])                          
  }
  setInterval(volgendefoto, 5000);
  var preloadimg=new Image();                             
  if(window.matchMedia("(max-width: 720px)").matches){  
    preloadimg.src=mobile_images[0];  
    //console.log('Preloading image: '+mobile_images[0]);                        
  }else if(window.matchMedia("(min-width:721px) and (max-width:1500px)").matches){
  	preloadimg.src=desktop_small_images[0]; 
  }else if(window.matchMedia("(min-width:1501px)").matches){
  	preloadimg.src=desktop_large_images[0]; 
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-image-mobile-cycle"] && !Shopify.designMode) return;
  try {
    
  //console.log('hero image');
  var mobile_image = document.getElementById("mobile-image");
  var i = 0;
  function volgendefoto() {
      i<mobile_images.length-1?i+=1:i=0;
      mobile_image.srcset=mobile_images[i];
      //console.log('Changed mobile image to: '+mobile_images[i])                          
  }
  setInterval(volgendefoto, 5000); 
  if(window.matchMedia("(max-width: 720px)").matches){
    var preloadimg=new Image();
    preloadimg.src=mobile_images[0];  
    //console.log('Preloading image: '+mobile_images[0]);                           
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-unified"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    document.querySelectorAll('.hero-unified').forEach(function (hero) {
      var slides  = Array.prototype.slice.call(hero.querySelectorAll('.hero-slide'));
      var speed   = parseInt(hero.dataset.speed || '5', 10) * 1000;
      var current = 0;

      if (slides.length <= 1) return;

      setInterval(function () {
        slides[current].classList.remove('is-active');
        current = (current + 1) % slides.length;
        slides[current].classList.add('is-active');
      }, speed);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
